import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";

import { createMessageContentService } from "./factory";

export const messageContentService = createMessageContentService(signalsService);
